'use strict';

import React from 'react';
import ReactGA from "react-ga4";

import {QuestionCircleFill} from "react-bootstrap-icons";

/**
 * A widget to display in the default case.
 */
const UnknownState = (props) => {
    ReactGA.gtag('event', 'exception', {
        description: `${props.name}: component unknown state`,
        fatal: true
    });

    return (
        <QuestionCircleFill title={`Couldn't determine which component to display in ${props.name}.`} />
    );
}

export default UnknownState;